/**
 * Theme Configuration
 * ----------------------------------------------------------
 */
config = {
    mediaQueries: {
      landscapeAll: 'screen and (orientation: landscape)',
      landscape: 'screen and (orientation: landscape), screen and (min-width: 48rem)',
      belowTablet: 'screen and (max-width: 47.99rem)',
      tablet: 'screen and (min-width: 48rem)',
      belowLaptop: 'screen and (max-width: 63.99rem)',
      laptop: 'screen and (min-width: 64rem)',
      belowDesktop: 'screen and (max-width: 64rem)',
      desktop: 'screen and (min-width: 64.01rem)',
      belowWidescreen: 'screen and (max-width: 79.99rem)',
      widescreen: 'screen and (min-width: 80rem)',
      belowExtrawide: 'screen and (max-width: 89.99rem)',
      extrawide: 'screen and (min-width: 90rem)'
    }
  };